import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    window.gtag?.("config", "G-EZS9CZ5R3Q", {
      page_path: location.pathname,
    });
  }, [location]);

  return null;
}
